import ProductTypeEnum from "../enums/ProductTipeEnum";
import editProductView from "../views/editProductView";
import NullProduct from "../entities/NullProduct";
import returnErrorView from "../helpers/returnErrorView";
import displayInfoContainer from "../components/infoContainer";
import returnHome from "../helpers/returnHome";
export function editProductViewLogic(store, mainContent) {
    var product = getProduct(store);
    viewRendering(mainContent, product);
    populateProductTypesSelectInput(product);
    formEvents(store);
}
//get product
function getProduct(store) {
    var productID = window.location.href.split("?")[1].split("=")[1];
    var product = store.getProductById(productID);
    if (product instanceof NullProduct) {
        returnErrorView();
    }
    return product;
}
//view rendering
function viewRendering(mainContent, product) {
    mainContent.innerHTML = editProductView(product);
    var editForm = document.getElementById("form");
    editForm["product-name"].value = product.name;
    editForm["product-image"].value = product.image;
    editForm["product-thumbnail"].value = product.thumbnail;
}
//Selector for product types loading
function populateProductTypesSelectInput(product) {
    var typeSelector = document.getElementById("type-selector");
    for (var item in Object.values(ProductTypeEnum)) {
        var newOption = document.createElement("option");
        newOption.value = Object.keys(ProductTypeEnum)[item];
        newOption.innerHTML = Object.values(ProductTypeEnum)[item];
        if (product.type == Object.values(ProductTypeEnum)[item]) {
            newOption.selected = true;
        }
        typeSelector.appendChild(newOption);
    }
}
function formEvents(store) {
    var editForm = document.getElementById("form");
    var submitButton = document.getElementById("edit-product-submit-button");
    var cancelButton = document.getElementById("cancel-edit-product-submit-button");
    submitButton.addEventListener("click", function (event) {
        event.preventDefault();
        try {
            var product = getProduct(store);
            verifyProductEdition(product, editForm);
            store.editProduct();
            displayInfoContainer("El producto ha sido editado correctamente.");
            returnHome();
        }
        catch (error) {
            displayInfoContainer("" + error);
        }
    });
    cancelButton.addEventListener("click", function (event) {
        event.preventDefault();
        displayInfoContainer("El producto no ha sido editado.");
        returnHome();
    });
}
//verify product creation according to Product Class rules
function verifyProductEdition(product, editProductForm) {
    product.name = editProductForm["product-name"].value;
    product.type = editProductForm["product-type"][editProductForm["product-type"].selectedIndex].text;
    product.price = parseFloat(editProductForm["product-price"].value);
    product.description = editProductForm["product-description"].value;
    product.image = editProductForm["product-image"].value;
    product.thumbnail = editProductForm["product-thumbnail"].value;
    product.stock = parseInt(editProductForm["product-stock"].value);
    product.discount = parseFloat(editProductForm["product-discount"].value);
}
